var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useI18n } from '@cta-portal/webapp-common/lib/hooks/translations/use-i18n';
import React from 'react';
import styled from 'styled-components';
import Table, { CellAlign, CellType } from '../../common/table';
export default function History(_a) {
    var history = _a.history;
    var t = useI18n().t;
    var labels = [
        {
            key: 'dateStart',
            label: t('common.date-start'),
            align: CellAlign.LEFT,
            size: 1,
        },
        {
            key: 'source',
            label: t('common.source'),
            align: CellAlign.CENTER,
            size: 1,
        },
        {
            key: 'vipPoints',
            label: t('common.vip-points'),
            align: CellAlign.CENTER,
            size: 1,
        },
        {
            key: 'dateEnd',
            label: t('common.date-end'),
            align: CellAlign.RIGHT,
            size: 1,
        },
    ];
    var rows = history.map(function (row, index) { return ({
        id: index.toString(),
        data: {
            dateStart: {
                type: CellType.TEXT,
                value: row.dateStart,
            },
            source: {
                type: CellType.TEXT,
                value: row.source,
            },
            vipPoints: {
                type: CellType.NUMBER,
                value: "".concat(row.vipPoints, " VP"),
            },
            dateEnd: {
                type: CellType.TEXT,
                value: row.dateEnd,
            },
        },
    }); });
    return (_jsx(Container, { children: _jsx(Table, { labels: labels, rows: rows }) }));
}
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  padding: 40px 64px;\n  width: 100%;\n\n  @media screen and (max-width: 824px) {\n    padding: 40px 16px 24px 16px;\n  }\n"], ["\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  padding: 40px 64px;\n  width: 100%;\n\n  @media screen and (max-width: 824px) {\n    padding: 40px 16px 24px 16px;\n  }\n"])));
var templateObject_1;
